<div class="card mb-3">
    <div class="card-header">
        <h6 class="card-title mb-0">Unidades de Negócio</h6>
        <small class="card-subtitle mb-0">Unidades de negócio que este cliente trabalha</small>
    </div>
    
    <form #form="ngForm" novalidate>
        <ul class="list-group list-group-flush">
            <ng-template ngFor let-entity [ngForOf]="entities" let-i="index">
                <li class="list-group-item select">
                    <label for="unidadeNegocio_{{i}}" class="col-form-label">
                        Unidade de Negócio
                    </label>
                    <div class="input-group">
                        <div class="input-group-prepend" *ngIf="canEdit">
                            <button type="button" class="btn btn-light" (click)="delete(i)">
                                <i class="far fa-trash-alt" aria-hidden="true"></i>
                            </button>
                        </div>
                        <select class="form-control" name="unidadeNegocio_{{i}}" id="unidadeNegocio_{{i}}"
                            [ngModel]="entity.idUnidadeNegocio || ''" (ngModelChange)="onSelectUnidadeNegocio(entity, $event)"
                            #unidadeNegocio="ngModel" [autofocus]="true" required="required" [disabled]="!canEdit || entity.mercados?.length > 0">
                            <option value="">Selecione a unidade de negócio...</option>
                            <option *ngFor="let unidade of unidadesNegocio" [ngValue]="unidade.id">{{unidade.nome}}</option>
                        </select>
                    </div>
    
                    <div class="container-children">
                        <sgt-cliente-unidade-negocio-mercado
                            #mercadoForm
                            [canEdit]="canEdit"
                            [idCliente]="idCliente"
                            [idUnidadeNegocio]="entity.idUnidadeNegocio"
                            [nomeUnidadeNegocio]="entity.nomeUnidadeNegocio"
                            [indexUnidadeNegocio]="i"
                            [itensTipos]="itensTipos"
                            [canEdit]="canEdit"
                            [entities]="entity.mercados">
                        </sgt-cliente-unidade-negocio-mercado>
                    </div>
                </li>
            </ng-template>            
            <li class="list-group-item options" *ngIf="canEdit && entities && entities.length > 0">
                <button type="button" class="btn btn-primary btn-add" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Unidade de Negócio
                </button>
            </li>
        </ul>
    </form>

    <div class="alert alert-info alert-no-entities" *ngIf="canEdit && (!entities || entities.length === 0)">
        <h5 class="title">
            <i class="fas fa-info" aria-hidden="true"></i>Nenhuma Unidade de Negócio Adicionada
        </h5>
        <button type="button" class="btn btn-primary" (click)="insert()">
            <i class="fas fa-plus" aria-hidden="true"></i> Começar a Adicionar
        </button>
    </div>
</div>
